/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const postCalendar = (params) => makeApiCall(`/events/calendar`, 'POST', params);

export const postCalendarList = (params) => makeApiCall(`/events/list`, 'POST', params);

export const getEventTypeList = (params) => makeApiCall(`/events/type`, 'GET', params);

export const postCalendarCreate = (params) => makeApiCall(`/events/create`, 'POST', params);

export const postCalendarDelete = (params) => makeApiCall(`/events/delete`, 'POST', params);

export const postCalendarPlottable = (params) => makeApiCall(`/events/plottable`, 'POST', params);

export const getViewCalendarEvent = (params) => makeApiCall(`/events/view`, 'POST', params);

export const getUpdateCalendarEvent = (params) => makeApiCall(`/events/update`, 'POST', params);
